import { render, staticRenderFns } from "./index-top-banner.vue?vue&type=template&id=c0e200d0&"
var script = {}
import style0 from "./index-top-banner.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports